/*
  Monsor order bump (vink-optie).

  Het vinkje voegt zelf niets toe en opent de drawer niet. Pas wanneer de
  bezoeker op de gewone "Toevoegen aan winkelwagen" klikt en het vinkje aan
  staat, liften we mee.

  Aanpak: we onderscheppen de submit van de koopform. Staat het vinkje aan,
  dan voegen we eerst het gekoppelde product toe en daarna laten we de
  koopform haar eigen toevoeging afhandelen. Het thema haalt dan de cart op
  met beide producten erin en tekent de drawer in een keer, zonder vertraging
  of nasprong.

  Prijssync: zolang het vinkje aan staat tellen we de bumpprijs op bij het
  bedrag in de koopknop (product-buy-price). De bundelkiezer schrijft dat
  bedrag zelf ook, dus we kijken met een MutationObserver mee en tellen na elke
  externe wijziging opnieuw op. De sticky koopbalk leest de knopprijs over en
  volgt daardoor vanzelf.

  Het vinkje staat standaard uit (EU-regels verbieden vooraf aanvinken van een
  betaalde toevoeging) en wordt na toevoegen weer uitgezet. Gaat de extra
  toevoeging om wat voor reden dan ook mis, dan voegt de koopform alsnog
  gewoon het hoofdproduct toe.
*/
(function () {
  var BASE_ATTR = 'data-monsor-bump-base';

  function formatMoney(cents) {
    try {
      if (window.theme && theme.Currency && theme.Currency.formatMoney && theme.settings) {
        var format = theme.settings.currencyCodeEnabled
          ? theme.settings.moneyWithCurrencyFormat
          : theme.settings.moneyFormat;
        if (format) return theme.Currency.formatMoney(cents, format);
      }
    } catch (e) {}
    return '\u20ac' + (cents / 100).toFixed(2).replace('.', ',');
  }

  // Leest een weergegeven bedrag terug naar centen. Werkt met "€36,00",
  // "36,00 EUR", "€1.234,50" en met punt als decimaalteken.
  function parseMoney(text) {
    if (!text) return null;
    var s = String(text).replace(/\s|&nbsp;/g, '').replace(/[^\d.,]/g, '');
    if (!s) return null;
    var m = s.match(/^(.*)([.,])(\d{2})$/);
    if (m) {
      var whole = m[1].replace(/[.,]/g, '');
      return (parseInt(whole || '0', 10) * 100) + parseInt(m[3], 10);
    }
    var plain = s.replace(/[.,]/g, '');
    if (!plain) return null;
    return parseInt(plain, 10) * 100;
  }

  function priceElements() {
    return Array.prototype.slice.call(document.querySelectorAll('product-buy-price'));
  }

  function createPriceSync(bumpPrice) {
    var on = false;
    var writing = false;
    var observer = null;

    function paint(el) {
      var base = el.getAttribute(BASE_ATTR);
      var cents = parseMoney(base);
      if (cents === null) return;
      var next = formatMoney(cents + bumpPrice);
      if (el.textContent.trim() === next) return;
      writing = true;
      el.textContent = next;
    }

    function adopt(el) {
      var current = el.textContent.trim();
      if (!current || parseMoney(current) === null) return;
      el.setAttribute(BASE_ATTR, current);
      paint(el);
    }

    function watch() {
      if (observer || !('MutationObserver' in window)) return;
      observer = new MutationObserver(function (mutations) {
        if (writing) {
          writing = false;
          return;
        }
        if (!on) return;
        var seen = [];
        mutations.forEach(function (m) {
          var node = m.target;
          var el = node.nodeType === 1
            ? node.closest('product-buy-price')
            : (node.parentElement ? node.parentElement.closest('product-buy-price') : null);
          if (!el || seen.indexOf(el) !== -1) return;
          seen.push(el);
          // De bundelkiezer of variantwissel heeft een nieuw bedrag geschreven:
          // dat is vanaf nu het basisbedrag waar de bump bovenop komt.
          adopt(el);
        });
      });
      observer.observe(document.body, { childList: true, subtree: true, characterData: true });
    }

    return {
      enable: function () {
        if (on) return;
        on = true;
        watch();
        priceElements().forEach(adopt);
      },
      disable: function () {
        if (!on) return;
        on = false;
        priceElements().forEach(function (el) {
          var base = el.getAttribute(BASE_ATTR);
          if (base === null) return;
          el.removeAttribute(BASE_ATTR);
          if (el.textContent.trim() === base) return;
          writing = true;
          el.textContent = base;
        });
      }
    };
  }

  function init(root) {
    if (root.dataset.bumpInit) return;
    root.dataset.bumpInit = '1';

    var checkbox = root.querySelector('.monsor-bump__check');
    var variantId = parseInt(root.getAttribute('data-bump-variant') || '0', 10);
    if (!checkbox || !variantId) return;

    var bumpPrice = parseInt(root.getAttribute('data-bump-price') || '0', 10);
    var priceSync = bumpPrice > 0 ? createPriceSync(bumpPrice) : null;

    function syncPrice() {
      if (!priceSync) return;
      if (checkbox.checked) {
        priceSync.enable();
      } else {
        priceSync.disable();
      }
    }

    checkbox.addEventListener('change', syncPrice);
    // Bij terugkeer op de pagina kan de browser het vinkje herstellen.
    syncPrice();

    document.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        // Tweede ronde: na onze toevoeging laten we het thema gewoon afhandelen.
        if (form.__monsorBumpPass) {
          form.__monsorBumpPass = false;
          return;
        }
        if (!checkbox.checked) return;

        e.preventDefault();
        e.stopImmediatePropagation();
        var submitter = e.submitter || null;

        function proceed() {
          form.__monsorBumpPass = true;
          if (form.requestSubmit) {
            form.requestSubmit(submitter || undefined);
          } else {
            form.submit();
          }
        }

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
        })
          .then(function () {
            checkbox.checked = false;
            syncPrice();
            proceed();
          })
          .catch(function () {
            // Toevoeging mislukt: voeg alsnog gewoon het hoofdproduct toe.
            proceed();
          });
      }, true); // capture: voor de afhandeling van het thema
    });
  }

  function boot() {
    document.querySelectorAll('.monsor-bump[data-bump-variant]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();